import React from "react";
import { useAuth } from "./AuthContext";
import { Navigate } from "react-router-dom";

const Protected: React.FC<{ roles?: string[]; children: React.ReactNode }> = ({ roles, children }) => {
    const { user, loading, error, reload } = useAuth();

    if (loading) {
        return (
            <div className="main">
                <div className="card">Загрузка…</div>
            </div>
        );
    }

    if (!user) {
        if (error && !/401|unauthorized/i.test(error)) {
            return (
                <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
                    <div style={{ width: "min(540px, 100%)", background: "#fff", borderRadius: 16, padding: 24, boxShadow: "0 18px 40px rgba(12,38,63,0.12)" }}>
                        <h2 style={{ marginTop: 0 }}>Не удалось проверить авторизацию</h2>
                        <p style={{ opacity: 0.8, lineHeight: 1.5 }}>
                            Приложение не смогло получить данные текущей сессии. Попробуйте повторить запрос.
                        </p>
                        <pre style={{ background: "#f6f8fa", padding: 12, borderRadius: 10, overflow: "auto" }}>{error}</pre>
                        <button
                            type="button"
                            onClick={reload}
                            style={{
                                border: 0,
                                borderRadius: 12,
                                background: "#0c263f",
                                color: "#fff",
                                padding: "12px 18px",
                                cursor: "pointer",
                            }}
                        >
                            Повторить
                        </button>
                    </div>
                </div>
            );
        }

        return <Navigate to="/login" replace />;
    }

    if (roles && !roles.some(r => user.roles?.includes(r))) {
        return (
            <div className="main">
                <div className="card">Нет прав доступа</div>
            </div>
        );
    }

    return <>{children}</>;
};

export default Protected;
